import { YOUTUBE_REGEX } from '../../../../../consts'

export const getYouTubeVideoId = (link: string) => {
  if (!link.match(YOUTUBE_REGEX)) {
    return null
  }

  return link.match(YOUTUBE_REGEX)?.groups?.id
}
